export const SHOW = 'header/SHOW';
export const HIDE = 'header/HIDE';
export const PERSIST_SEARCH = 'header/PERSIST_SEARCH';
export const FOCUSED = 'header/FOCUSED';

export const FETCH_HEADER_REQUEST = 'header/FETCH_HEADER_REQUEST';
export const FETCH_HEADER_SUCCESS = 'header/FETCH_HEADER_SUCCESS';
export const FETCH_HEADER_FAILURE = 'header/FETCH_HEADER_FAILURE';
